export default __webpack_public_path__ + "static/haimor-9b7ff83b305b91921c09c3948ad9a992.jpg";